import React, { useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import rcmlogo from '../../assets/rcmlogo.png';
import { PostApiMethod } from "../../core/services/apiService";
import { DisplayToaster } from "../../core/services/sharedService";

const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [disable, setDisable] = useState(false);
    const [admin, setAdmin] = useState<any>("");
    const [isLoading, setIsLoading] = React.useState(false);

    const pageDisable = () => {
        setIsLoading(true);
        document.body.classList.add("screen-disable");
    };

    const pageEnable = () => {
        setIsLoading(false);
        document.body.classList.remove("screen-disable");
    };

    const handleSubmit = (e: any) => {
        setDisable(true);
        e.preventDefault();
        if (!email) {
            DisplayToaster("bg-danger", "Email is required");
            setDisable(false);
        } else {
            let pattern = new RegExp(/^\w+([\+\.-]?\w+)*@\w+([\+\.-]?\w+)*(\.\w{2,3})+$/);
            if (!pattern.test(email.trim())) {
                DisplayToaster("bg-danger", "Enter valid email address");
                setDisable(false);
                return false;
            }
            setIsLoading(true);
            pageDisable();
            const postdata = {
                email: email?.toLowerCase().trim()
            }
            const loginas = admin ? "admin" : "tenant";

            PostApiMethod(loginas + '/auth/reset_password', postdata)
                .then((res) => {
                    pageEnable();
                    if (res.data.status === "Success") {
                        DisplayToaster("bg-success", res.data.data);
                    }
                    setIsLoading(false);
                    setDisable(false);
                }).catch((err) => {
                    pageEnable();
                    console.log(err);
                    DisplayToaster("bg-danger", err.response.data.message);
                    setDisable(false);
                })
        }
    }

    return (
        <>
            <div className="resetcard">
                <Card className="" >
                    <Card.Img src={rcmlogo} alt="Card image" className="rcmlogo" />

                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <div className="m-3">
                                <div className='mb-2'>
                                    <label><b>Enter Your Email Here</b> </label>
                                </div>
                                <div>
                                    <input type="text" name="email" onChange={(e) => { setEmail(e.target.value); setDisable(false) }} className="form-control input-textgenere" />
                                </div>
                            </div>
                            <div className="m-3">
                                <div className="row">
                                    <div className="col-md-6 ml-3" >
                                        <input type="checkbox" name="admin" className="form-check-input" onChange={(e) => { setAdmin(e.target.checked) }} />&nbsp;&nbsp;&nbsp;&nbsp;
                                        <label>Login As Admin</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="text-center" >
                                    <Button type="submit" style={{ backgroundColor: '#0187c4' }} disabled={disable} onClick={handleSubmit} className="m-3">Submit</Button>
                                    <Link to="/sign-in"><Button className="btn btn-secondary">Cancel</Button></Link>
                                </div>
                            </div>
                        </Form>

                    </Card.Body>
                </Card>
            </div>
        </>
    )
}

export default ResetPassword;